import React from "react";
import GLYPHS from "./icons.generated";

/*
 * Platform icon for the auth screens: Ionicons outline (design system §
 * Iconography), same contract as @pluginlive-technologies/ui's <Icon>.
 * ponytail: auth-react can't take the ui package in the design lane; swap this
 * for `@pluginlive-technologies/ui/Icon` when the app adopts the package.
 */
export default function Icon({ name, label, className }) {
  const a11y = label ? { role: "img", "aria-label": label } : { "aria-hidden": true };
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      focusable="false"
      className={["pl-icon", className].filter(Boolean).join(" ")}
      {...a11y}
      // Static glyph markup from ionicons — never user input.
      dangerouslySetInnerHTML={{ __html: GLYPHS[name] }}
    />
  );
}
